export const ReservationLogType = Object.freeze({
  CREATED: 1,
  PAID: 2,
  DELETED: 3,
  EXPIRED: 4,
  MOVED: 5,
})

export const ReservationLogTypeLabels = Object.freeze({
  [ReservationLogType.CREATED]: 'Utworzona',
  [ReservationLogType.PAID]: 'Opłacona',
  [ReservationLogType.DELETED]: 'Usunięta',
  [ReservationLogType.EXPIRED]: 'Wygasła',
  [ReservationLogType.MOVED]: 'Przeniesiona',
})

export const ReservationLogTypeConfig = Object.freeze({
  [ReservationLogType.CREATED]: { icon: 'plus', variant: 'primary', paidVariant: 'success' },
  [ReservationLogType.PAID]: { icon: 'currency-dollar', variant: 'success' },
  [ReservationLogType.DELETED]: { icon: 'x', variant: 'danger' },
  [ReservationLogType.EXPIRED]: { icon: 'clock', variant: 'danger' },
  [ReservationLogType.MOVED]: { icon: 'arrow-right', variant: 'info' },
})
